/** @format */

import {Box, Chip, Typography} from '@mui/material';
import {styled} from '@mui/material/styles';

import SecondaryMediumButton from 'components/buttons/SecondaryMediumButton';

export const Header = styled(Box)(() => ({
  height: '80px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

export const ProjectButton = styled(SecondaryMediumButton)(({theme}) => ({
  padding: theme.spacing(4, 8),
  borderRadius: theme.spacing(2),
  background: theme.palette.semantic_dark?.surface.surface1,
  width: '100%',
  boxShadow: '1px 1px 5px 0px rgba(0, 0, 0, 0.05)',
  color: theme.palette.semantic_dark?.surface.onSurface,
  fontSize: '14px',
  fontWeight: 400,

  '&:hover': {
    background: theme.palette.semantic_dark?.surface.surface1,
  },
}));

export const Description = styled(Typography)(({theme}) => ({
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '18px',
  color: theme.palette.figma_gray_middle_dark?.main,
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(1),
}));

export const CustomChip = styled(Chip)(({theme}) => ({
  color: theme.palette.figma_gray_middle_dark?.main,
  cursor: 'pointer',
  marginTop: theme.spacing(2),
}));
